import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { cereateDemandeLicence } from 'src/app/store/actions/demande-licence.action';
import { selectUserProfil } from 'src/app/store/selector/user-profil.selector';

@Component({
  selector: 'app-demand-licence',
  templateUrl: './demand-licence.component.html',
  styleUrls: ['./demand-licence.component.css']
})
export class DemandLicenceComponent implements OnInit {
  // Objet pour stocker les données du formulaire
  demande: any = {
    typeDemande: 'NOUVELLE',
    licenceId: null,
    partenaireId: null,
    pays: '',
    typeLicence: 'FREE',
    commentaire: ''
  };

  isSubmitting: boolean = false;
  showConfirmationModal: boolean = false;

  // Données
  utilisateurConnecte: any;
  licencesUtilisateur: any[] = [];
  partenairesDisponibles: any[] = [];
  licenceSelectionnee: any = null;
  today: Date = new Date();
  utilisateur$: Observable<any>;
  constructor(private router: Router, private store: Store<any>) {
    this.utilisateur$ = this.store.pipe(select(selectUserProfil))
  }
  utilisateur: any = {}
  ngOnInit() {
    this.loadUtilisateurConnecte();
    this.loadLicencesUtilisateur();
    this.loadPartenairesDisponibles();
    this.utilisateur$.subscribe((profil: any) => {
      this.utilisateur = { ...profil.responseDAO }
    })

  }

  // Méthodes utilitaires
  isRenouvellement(): boolean {
    return this.demande.typeDemande === 'RENOUVELLEMENT';
  }

  isNouvelleLicence(): boolean {
    return this.demande.typeDemande === 'NOUVELLE';
  }

  onTypeDemandeChange() {
    // Réinitialiser les champs conditionnels quand le type change
    if (this.isRenouvellement()) {
      this.demande.partenaireId = null;
      this.demande.pays = '';
    } else {
      this.demande.licenceId = null;
      this.licenceSelectionnee = null;
    }
  }

  onLicenceChange() {
    this.licenceSelectionnee = this.licencesUtilisateur.find(l => l.id == this.demande.licenceId);
  }

  getStatusText(status: string): string {
    const statusMap: { [key: string]: string } = {
      'ACTIVE': 'Active',
      'EXPIRED': 'Expirée',
      'SUSPENDED': 'Suspendue',
      'INACTIVE': 'Inactive'
    };
    return statusMap[status] || status;
  }

  // Validation personnalisée


  // Soumission du formulaire
  submitDemande() {

      this.isSubmitting = true;

      const demandeData: any = {
        typeDemande: this.demande.typeDemande,
        statutDemande: 'EN_ATTENTE',
        dateSoumission: new Date().toISOString().split('T')[0],
        commentaire: this.demande.commentaire,
        licence: this.isRenouvellement() ?
          this.licencesUtilisateur.find(l => l.id == this.demande.licenceId) : null,
        utilisateur: this.utilisateurConnecte
      };

      // Pour une nouvelle licence, inclure les informations supplémentaires
      if (this.isNouvelleLicence()) {
        const demandeLicence = {
          typeDemande: "NOUVELLE",
          statutDemande: "EN_TRAITEMENT",
          typeLicence: this.demande.typeLicence,
          commentaire: this.demande.commentaire,
          utilisateur: {
            id: +localStorage.getItem("ConnectedUser")!
          }
        }

       this.store.dispatch(cereateDemandeLicence(demandeLicence));
      }

      // Simulation d'appel API
      // this.demandeService.createDemande(demandeData).subscribe({
      //   next: (response) => {
      //     this.isSubmitting = false;
      //     this.showConfirmationModal = true;
      //   },
      //   error: (error) => {
      //     this.isSubmitting = false;
      //     console.error('Erreur lors de la soumission:', error);
      //   }
      // });

      // Pour l'exemple, on simule un succès après 1 seconde
      setTimeout(() => {
        this.isSubmitting = false;
        this.showConfirmationModal = true;
      }, 1000);

  }

  loadUtilisateurConnecte() {
    // Récupérer l'utilisateur connecté
    // this.authService.getCurrentUser().subscribe(user => {
    //   this.utilisateurConnecte = user;
    // });

    // Données simulées
    this.utilisateurConnecte = {
      id: 1,
      nom: 'Dupont',
      prenom: 'Jean',
      email: 'jean.dupont@example.com'
    };
  }

  loadLicencesUtilisateur() {
    // Charger les licences de l'utilisateur connecté
    // this.licenceService.getLicencesByUser(this.utilisateurConnecte.id).subscribe(licences => {
    //   this.licencesUtilisateur = licences;
    // });

    // Données simulées
    this.licencesUtilisateur = [
      {
        id: 1,
        numerolicence: 'LIC-2024-001',
        partenaire: { nom: 'Entreprise A' },
        isPro: true,
        status: 'ACTIVE'
      },
      {
        id: 2,
        numerolicence: 'LIC-2024-002',
        partenaire: { nom: 'Entreprise B' },
        isPro: false,
        status: 'EXPIRED'
      }
    ];
  }

  loadPartenairesDisponibles() {
    // Charger les partenaires disponibles
    // this.partenaireService.getPartenairesActifs().subscribe(partenaires => {
    //   this.partenairesDisponibles = partenaires;
    // });

    // Données simulées
    this.partenairesDisponibles = [
      { id: 1, nom: 'Entreprise A', code: 'ENT-A' },
      { id: 2, nom: 'Entreprise B', code: 'ENT-B' },
      { id: 3, nom: 'Entreprise C', code: 'ENT-C' }
    ];
  }

  closeConfirmationModal() {
    this.showConfirmationModal = false;
    this.router.navigate(['/demand-licence']);
  }

  cancel() {
    this.router.navigate(['/dashboard']);
  }
}

